export default {
    name: 'DesignDisclosure',
    props: {
        open: {
            type: Boolean,
            required: true
        }
    }
};
